import { useEffect, useCallback, memo } from "react";
import { useQuery } from "react-query";
import { defaultQueryFn, useEventEmitter, USE_RETRIEVE_DATA_EVENTS, allActions } from "@ace/react-utilities";
import { useDispatch } from "react-redux";
import executeTealium from 'tracking/executeTealium';
import * as Sentry from "@sentry/react";

export const DashboardComponentName = "Dashboard";
const GetDashboardVariantID = () => {
    //console.log('[GetDashboardVariantID] Accessing GetDashboardVariantID.');
    return (new URLSearchParams(window.location.search)).get('variant');
};
export const DashboardVariantID = GetDashboardVariantID(); // memo((new URLSearchParams(window.location.search)).get('variant'));

export const formatDashboardRetrievalUrl = (variantID) => {
    return `/api/dashboard/${variantID || 1}/`;
}

export const dashboardRetrievalUrl = formatDashboardRetrievalUrl(DashboardVariantID);

const dashboardQueryFn = async () => {
    const json = await defaultQueryFn(dashboardRetrievalUrl);
    return json;
};

const useDashboardQueryBase = (queryOpts = {}) => {
    return useQuery(DashboardComponentName, { 
        queryFn: dashboardQueryFn,
        onError: (err) => { 
            Sentry.captureException(err);
            console.error(err);
        },
        ...queryOpts
    });
}

export const useDashboardQuery = () => {
    const applyEmitterHandler = useEventEmitter(DashboardComponentName);
    const dispatch = useDispatch();

    useEffect(() => {
        applyEmitterHandler((emitter) => {
            emitter.once(USE_RETRIEVE_DATA_EVENTS.ON_FETCH_SUCCESS, (data) => {
                executeTealium(data.TealiumData);
            });
        });
    }, [applyEmitterHandler]);

    return useDashboardQueryBase({
        onError: (err) => { 
            Sentry.captureException(err);
            applyEmitterHandler((emitter) => {
                emitter.emit(USE_RETRIEVE_DATA_EVENTS.ON_FETCH_ERROR, err);
            });
        },
        onSuccess: (data) => {
            dispatch(allActions.userActions.setUserData(data.User));

            Sentry.setUser({ id: data.User.CustNmbr });
    
            dispatch(allActions.dashboardTabActions.setDashboardTabs(data.TabCenter));
    
            applyEmitterHandler((emitter) => {
                emitter.emit(USE_RETRIEVE_DATA_EVENTS.ON_FETCH_SUCCESS, data);
            });
        }
    });
};

export const useDashboardTabQuery = (dashboardTabKey) => useDashboardQueryBase({
    select: useCallback(
        (data) => data.TabCenter.Tabs.find((tab) => tab.TabKey === dashboardTabKey),
        [dashboardTabKey]
    )
});

export const useDashboardUserQuery = () => useDashboardQueryBase({
    select: (data) => data.User
});
